import {Funcionalidad} from './funcionalidad';

export class Rol {
    public id: number;
    public nombre: String;
    public descripcion: String;
    public numFuncionalidad: number;
    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;
    public lstFuncionalidades: Funcionalidad[];

    constructor(id?: number,
                nombre?: String,
                descripcion?: String,
                numFuncionalidad?: number,
                lstFuncionalidades?: Funcionalidad[],
                logEstatusRegistro?: string,
                logUsernameRegistro?: string,
                logFechaRegistro?: string,
                logUsernameModificacion?: string,
                logFechaModificacion?: string
    ) {
        this.id = id;
        this.nombre = nombre;
        this.numFuncionalidad = numFuncionalidad;
        this.descripcion = descripcion;
        this.lstFuncionalidades = lstFuncionalidades;

        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;

    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/roles/recursos/modelo/rol.ts